import request from './request';

export function login(payload) {
  return request.post('/auth/admin/login', payload);
}

